var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var buttonElement = require('../components/button');

var profileGroups = {};

profileGroups.oninit = function () {
  var ctrl = this;
  ctrl.groupsToShow = [];
};


profileGroups.view = function (vnode) {
  var ctrl = this;
  var attrs = vnode.attrs || {};
  return m('div', [
    m(paginationWithSearch, {
      data: attrs.groups,
      newNode: attrs.newNode,
      dataToShow: ctrl.groupsToShow,
      placeHolder: 'Search group',
      itemsPerPage: 20,
      fieldsToSearch: ['name']
    },[
      m('table.w-100.f4.mb2.mt2', [
        m('thead', [
          m('tr', [
            m('th.ph0.pv0.tl', 'Name'),
            m('th.ph0.pv0.tl', 'Notification Preference'),
          ])
        ]),
        m('tbody', [
          ctrl.groupsToShow.map(function (group) {
            if (!group['@rid']) {
              return m('tr', [
                m('td.tl.pv0.nowrap', [
                  m('select',{style:{'visibility':'hidden'}}, 'No Data')
                ]),
                m('td.tl.pv0.truncate'),
              ])
            }else{
              return m('tr', [
                m('td.tl.pv0.nowrap', m(m.route.Link, {href: '/group/' + group['@rid'].slice(1)}, group.name)),
                m('td.tl.pv0.truncate', [
                  m('select', {
                    onchange: function (ev){ 
                      var previousPreference = group.notificationPreference;
                      var nextPreference = ev.target.value;
                      group.notificationPreference = nextPreference;
                      if (typeof attrs.onPreferenceSaving === 'function') {
                        attrs.onPreferenceSaving(group);
                      }
                      loaders.requestWithLoader({
                        method : 'PUT',
                        url: `/api/v1/member/${group.memberEdgeRid.slice(1)}`,
                        body: {
                          notificationPreference: nextPreference === 'null' ? null : nextPreference
                        }
                      })
                      .then(function () {
                        if (typeof attrs.onPreferenceSave === 'function') {
                          attrs.onPreferenceSave(group);
                        }
                      })
                      .catch(function (err) {
                        group.notificationPreference = previousPreference;
                        if (typeof attrs.onPreferenceError === 'function') {
                          attrs.onPreferenceError(err);
                        }
                      })
                      .finally(function () {
                        m.redraw();
                      })
                    },
                    value: group.notificationPreference == undefined ? 'null' : group.notificationPreference
                  },[
                    m('option', {value: 'null'}, 'Email + Sms'),
                    m('option', {value: 'email'}, 'Email'),
                    m('option', {value: 'sms'}, 'Sms'),
                    m('option', {value: 'disabled'}, 'Disable notifications')
                  ])
                ]),
              ])
            }
            
          })
        ])
      ])
    ]),
  ]);
}

module.exports = profileGroups;
